module.exports = __webpack_public_path__ + "static/img/3.6aa71de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn/3.png
// module id = Nkg3
// module chunks = 1